module.exports = __webpack_public_path__ + "img/pic_map_footer.2eb55488.png";